import React from 'react';

const scrollTop = () => {
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)){
        window.scrollTo(0, 0);
    } else {
        let el = document.scrollingElement || document.body;
        el.scrollTop = 0;
    }
}

const focusElementById = (id: string | null) => {
    if (id) {
        document.getElementById(id)?.focus()
    }
}

const replaceImgOnError = (
    e: React.SyntheticEvent<HTMLImageElement, Event>,
    imagePath?: string,
    alt?: string,
    title?: string
) => {
    e.currentTarget.src = imagePath ?? getAbsoluteImagePath("/assets/img/no-image.jpg");
    e.currentTarget.alt = alt ?? "image not found"
    e.currentTarget.title = title ?? "image not found"
}

const getAbsoluteImagePath = (path: string): string => {
    if (process.env.NODE_ENV === "development") {
        return path;
    } else {
        return process.env.REACT_APP_NEOBOOKING_URI ? process.env.REACT_APP_NEOBOOKING_URI + path : path
    }
}

const getAbsoluteImagePathResalys = (path: string): string => {
    if (process.env.NODE_ENV === "development") {
        return path;
    } else {
        return process.env.REACT_APP_RESALYS_FILE_URI ? process.env.REACT_APP_RESALYS_FILE_URI + "customer_html/icons/" + path : path
    }
}

const htmlDecode = (input: string) => {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent ?? "";
}

export { scrollTop, focusElementById, replaceImgOnError, getAbsoluteImagePath, getAbsoluteImagePathResalys, htmlDecode }